var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIrrigationChannel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 29.5,
    r: 29.5,
    fill: "#5E5E5E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16V43H20.1935L11.6576 16H8Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3549 43H51.5484V16H47.8912L39.3549 43Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7736 42.7196C31.5848 42.7196 32.7932 41.4127 34.6044 41.4127C35.5059 41.4127 36.474 41.8303 37.2256 42.1543L38.2664 38.6208C37.037 38.265 35.9989 37.4938 34.6049 37.4938C32.7937 37.4938 31.5857 38.7998 29.774 38.7998C27.962 38.7998 26.7548 37.4938 24.9432 37.4938C23.5492 37.4938 22.5115 38.265 21.2821 38.6208L22.3229 42.1543C23.0737 41.8303 24.0422 41.4127 24.9432 41.4127C26.7548 41.4127 27.9629 42.7196 29.7736 42.7196Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7746 23.499C31.5731 23.499 32.772 22.1926 34.5706 22.1926C36.3696 22.1926 37.5685 23.499 39.367 23.499C40.8516 23.499 41.9324 22.6185 43.2746 22.3075L41.929 26.8492C41.4865 27.0003 39.8787 27.4188 39.3661 27.4188C37.568 27.4188 36.3691 26.1119 34.5702 26.1119C32.7716 26.1119 31.5723 27.4188 29.7742 27.4188C27.9756 27.4188 26.7767 26.1119 24.9782 26.1119C23.1796 26.1119 21.9803 27.4188 20.1818 27.4188C19.6696 27.4188 18.0618 27.0008 17.6194 26.8492L16.2742 22.3075C17.6163 22.6185 18.6963 23.499 20.1813 23.499C21.9799 23.499 23.1788 22.1926 24.9777 22.1926C26.7763 22.1926 27.9747 23.499 29.7737 23.499H29.7746Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7747 31.1496C31.5858 31.1496 32.793 29.8427 34.6038 29.8427C36.4149 29.8427 37.6225 31.1496 39.4337 31.1496C39.8727 31.1496 40.2759 31.0734 40.6613 30.9584L39.4328 35.0685C37.6221 35.0685 36.4149 33.7625 34.6033 33.7625C32.7926 33.7625 31.585 35.0685 29.7742 35.0685C27.9635 35.0685 26.7563 33.7625 24.9452 33.7625C23.134 33.7625 21.9268 35.0685 20.1156 35.0685L18.8876 30.9584C19.273 31.0738 19.6767 31.1496 20.1152 31.1496C21.9264 31.1496 23.1335 29.8427 24.9447 29.8427C26.7559 29.8427 27.9631 31.1496 29.7738 31.1496H29.7747Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIrrigationChannel);
export default __webpack_public_path__ + "static/media/Irrigation_channel.6d187e9afba6b1c6d7bfe51a66e5977e.svg";
export { ForwardRef as ReactComponent };